// Certifications « hands-on » (performance-based) : sur celles-ci, on présente
// l'expérience Lab (terminal kubectl simulé) au lieu du QCM. Le QCM reste en
// base de données — il n'est simplement plus proposé à l'utilisateur, ce qui
// rend le basculement 100 % réversible (aucune donnée supprimée).

import { getLabsForCert } from './labs';

// slug -> a-t-on des labs prêts ? (sinon on affiche « en préparation »)
export const HANDS_ON_CERTS: Record<string, { labsReady: boolean }> = {
  'kubernetes-certified-application-developer-ckad': { labsReady: true },
  'kubernetes-certified-administrator-cka': { labsReady: true },
  'kubernetes-security-specialist-cks': { labsReady: true },
  // Linux/Red Hat : nécessite un simulateur bash séparé (à venir).
  'red-hat-certified-engineer-rhce': { labsReady: false },
};

export function isHandsOnCert(slug: string | null | undefined): boolean {
  return !!slug && slug in HANDS_ON_CERTS;
}

export function hasReadyLabs(slug: string | null | undefined): boolean {
  if (!slug) return false;
  const entry = HANDS_ON_CERTS[slug];
  return !!entry && entry.labsReady && getLabsForCert(slug).length > 0;
}
